import {
  AppstoreOutlined, BarChartOutlined, CalculatorOutlined, HomeOutlined, TeamOutlined
} from '@ant-design/icons';
import {
  ADMIN_ACCOUNTING, ADMIN_ANALYTICS, ADMIN_DASHBOARD, ADMIN_PRODUCTS, ADMIN_USERS
} from 'constants/routes';
import React from 'react';
import { NavLink } from 'react-router-dom';

const adminLinks = [
  {
    to: ADMIN_DASHBOARD, label: 'Dashboard', icon: HomeOutlined, exact: true
  },
  { to: ADMIN_PRODUCTS, label: 'Products', icon: AppstoreOutlined },
  { to: ADMIN_ANALYTICS, label: 'Analytics', icon: BarChartOutlined },
  { to: ADMIN_ACCOUNTING, label: 'الحسابات', icon: CalculatorOutlined },
  { to: ADMIN_USERS, label: 'Users', icon: TeamOutlined }
];

const SideNavigation = () => (
  <aside className="sidenavigation">
    <div className="sidenavigation-wrapper">
      {adminLinks.map((link) => {
        const Icon = link.icon;
        return (
          <div className="sidenavigation-item" key={link.to}>
            <NavLink
              activeClassName="sidenavigation-menu-active"
              className="sidenavigation-menu"
              exact={link.exact}
              to={link.to}
            >
              <Icon />
              <span>{link.label}</span>
            </NavLink>
          </div>
        );
      })}
    </div>
  </aside>
);

export default SideNavigation;
